import { filterCsvDataByVisibleColumns } from '@/lib/exportCsv';

export function getStaticDataTypeExportKeysByColumn(t: (key: string) => string): Record<string, readonly string[]> {
  return {
    sno: ['SN'],
    staticDataTypeName: [t('logsManagement.staticDataType.page.table.staticDataType')],
    staticDataTypeDescription: [t('logsManagement.staticDataType.page.table.staticDataDescription')],
  };
}

export function keepVisibleDataTypeExportColumns(
  rows: Array<Record<string, unknown>>,
  visibleColumnIds: readonly string[],
  exportKeysByColumn: Record<string, readonly string[]> = getStaticDataTypeExportKeysByColumn((key) => key),
) {
  return filterCsvDataByVisibleColumns(rows, visibleColumnIds, exportKeysByColumn);
}
